import styled from 'styled-components';
const VideoWrapper = styled.div`
  width: 100%;
  max-width: 860px;
  height: auto;
`;

export const VideoWrapperInner = styled.div`
	position: relative;
	height: 0;
	padding-bottom: ${({ ratio }) => `calc((${ratio[1]} / ${ratio[0]}) * 100%)`};
	box-shadow: 0 0 10px rgba(00, 00, 00, 0.5);
	cursor: pointer;
	> iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	.video-poster-fallback{
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		object-fit: cover;
		width: 100%;
		height: 100%;
        max-width: 100%;
        max-height: 100%;
	}
	.video-placeholder {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-size: cover;
		background-position: center center;
	}
	.play-video-button {
		width: 100px;
		height: 100px;
		margin: auto;
		position: absolute;
		border: 0;
		background: none;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		cursor: pointer;
		.self {
			background-color:  ${({theme}) => theme.colours.red};
			text-align: center;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			content: "";
			width: 100px;
			height: 100px;
			min-width: 100px;
			min-height: 100px;
			align-self: center;
			color: #fff;
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			margin: auto;
			border: 0;
			transition: all 0.4s ease-in-out;
			svg {
				width: 31px;
				height: 38px;
				fill: #fff;
			}
			&:hover {
				background-color: ${({theme}) => theme.colours.yellow};
				svg{
					fill: ${({theme}) => theme.colours.red};
				}
			}
		}
		@media (max-width: 650px){
			width: 50px;
			height: 50px;
			min-width: 50px;
			min-height: 50px;
			.self{
				width: 50px;
				height: 50px;
				min-width: 50px;
				min-height: 50px;
				svg{
					width: 20px;
					height: 20px;
				}
			}
		}
	}
`;

export default VideoWrapper;

export const Notification = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #c1462a;
  color: #fff;
  padding: 20px;
  border-radius: 4px;
  text-align: center;
  z-index: 1;
    width: 640px;
    max-width: 80%;
  .bean-graphic{
      width: 230px;
      height: 230px;
      display: flex;
      justify-content: center;
      align-items: center;
	  justify-self: center;
      position: relative;
    margin: auto auto 20px auto;
      .spiral{
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
		  width: 100%;
		  height: 100%;
      }
      .inner-bean{
          width: 120px;
      }
  }  
  p {
      font-size: 20px;
      color: #fff;
      text-align: center;
      display: block;
	  width: 460px;
	  margin: auto auto 10px auto;
	  max-width: 80%;
    @media (max-width: 650px) {
        max-width: 100%;
    }
  }
  .small-text {
      margin-bottom: 15px;
      font-size: 16px;
      color: #fff;
      display: block;
      text-align: center;
  }

  button {
      background-color: ${({theme}) => theme.colours.yellow};
      color: #c1462a;
      border: 2px solid ${({theme}) => theme.colours.yellow};
      padding: 20px 44px;
      cursor: pointer;
	  border-radius: 43px;
	  margin: 20px auto;
	  font-size: 20px;
	  font-weight: 900;
      transition: all 0.4s ease-in-out;
      position: relative;
      z-index: 100;
    @media (max-width: 650px) {
      padding: 10px 20px;
    }
    &:hover {
        background-color: #c1462a;
        border: 2px solid ${({theme}) => theme.colours.yellow};
        color: ${({theme}) => theme.colours.yellow};
    }
  }
`;